import { render, staticRenderFns } from "./multiplyChoiceButton.vue?vue&type=template&id=f21941ee"
import script from "./multiplyChoiceButton.vue?vue&type=script&lang=js"
export * from "./multiplyChoiceButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports